module.exports = __webpack_public_path__ + "static/media/Step5b.9fa4c8b6.jpg";